import React, { useEffect } from "react";
import { Typography } from "@material-ui/core";
import FeedComponent from "./FeedComponent";
import axios from "axios";
import { useSelector, shallowEqual } from 'react-redux'
import { useState } from "react";
import Swal from 'sweetalert2'
import { fetchFeed } from "./api";

const _data = [
  {
    avatar:
      "https://cdn.pixabay.com/photo/2021/01/04/10/41/icon-5887126_960_720.png",
    img:
      "https://ipt.imgix.net/200575/x/0/iceland-photo-tours10.jpg?ar=1.91%3A1&w=1200&fit=crop",
  },
  {
    avatar:
      "https://images.unsplash.com/photo-1548048876-54a717fa3f8c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXRodW1ibmFpbHx8NDM4OTU4M3x8ZW58MHx8fHw%3D&auto=format&fit=crop&w=420&q=60",
    img:
      "https://webartdevelopers.com/blog/wp-content/uploads/2021/01/full-screen-carousel-with-navbar.jpg",
  },
  {
    avatar:
      "https://images.unsplash.com/photo-1513956589380-bad6acb9b9d4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTh8fGJveXN8ZW58MHx8MHx8&w=1000&q=80",
    img:
      "https://wowslider.com/sliders/demo-69/data1/images/mountainlandscape.jpg",
  },
  {
    avatar:
      "https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/0177cd0d-ed6c-4f92-8e00-a4138579d909/de927r6-9daa8787-a752-4ac0-aaf6-5f19fd97821a.jpg/v1/fill/w_1280,h_1536,q_75,strp/boy_portrait_by_uyenthainguyen_de927r6-fullview.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTUzNiIsInBhdGgiOiJcL2ZcLzAxNzdjZDBkLWVkNmMtNGY5Mi04ZTAwLWE0MTM4NTc5ZDkwOVwvZGU5MjdyNi05ZGFhODc4Ny1hNzUyLTRhYzAtYWFmNi01ZjE5ZmQ5NzgyMWEuanBnIiwid2lkdGgiOiI8PTEyODAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.OiGxcGzb0hQ28DI3uPZbOuvCLpfiWKH9_xhaQhP1KkI",
    img:
      "https://hueandhatchet.com/wp-content/uploads/2020/10/Clarity-Slider-Header-1024x683.jpg",
  },
];

const Feeds = () => {
  const { user } = useSelector(({ auth }) => auth, shallowEqual);
  const [feed, setFeed] = useState([]);
  const [pending, setPending] = useState(false);
  const [page, setPage] = useState(0);

  useEffect(() => {
    GetFeed()
  }, []);
  const GetFeed = async () => {
    setPending(true);
    try{
      const res = await fetchFeed(user.id, page);
      setFeed(res.posts)
    }catch(ex){
      let error = ex.response ? ex.response.data.message : ex.message;
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error,
      })
    }finally{
      setPending(false);
    }
  }
  return (
    <div>
      <div className="col-sm-12 mb-5">
        <Typography variant="h4" className="font-weight-bold text-muted">
          Feeds
        </Typography>
      </div>
      
      {!pending && feed.length == 0 && <h1 className="text-center mt-5">No Feed available</h1>}
      <div>
        {feed.map((x) => (
          <FeedComponent feed={x} />
        ))}
      </div>
      {pending && <div className="w-100 d-flex align-items-center justify-content-between mb-2">
        <div
          class="spinner-border text-danger mx-auto"
          role="status"
        ></div>
      </div>}
    </div>
  );
};

export default Feeds;
